import React from 'react';
import { object, func } from 'prop-types';
import { InstantSearch,Configure } from 'react-instantsearch-dom';


class AlgoliaSearchPage extends React.Component {
	static propTypes = {
		render: func.isRequired,
		query: object,
		onRefresh: func.isRequired,
		onSearchStateChange: func.isRequired
	}
	constructor(props) {
		super(props);
		const { query } = props;
		this.state = {
			searchState: {
				attributeForMyQuery: query && query['word']
			}
		};
	}
	render() {
		const { refreshSearchQuiz, onRefresh, onSearchStateChange, ...props } = this.props;
		return <InstantSearch
			key={refreshSearchQuiz}
			appId={process.env.REACT_APP_ALGOLIA_SEARCH_APP_ID}
			apiKey={process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY}
			indexName={process.env.REACT_APP_ALGOLIA_SEARCH_INDEX_NAME}
			refresh={refreshSearchQuiz}
			searchState={this.state.searchState}
			onSearchParameters={(args, context, props) => {
				refreshSearchQuiz && onRefresh();
			}}
			onSearchStateChange={(searchState) => {
				// todo ここでaction->headerに検索完了を通知する
				// use the searchState
				onSearchStateChange(searchState.attributeForMyQuery);
				this.setState({ searchState });
			}}
		>
			<Configure
				filters="published>0"
			/>
			{props.children}
		</InstantSearch>;
	}
}

export default AlgoliaSearchPage;